import { Box } from '@mui/material';

interface LoadingSpinnerProps {
  size?: number;
  fullScreen?: boolean;
}

export function LoadingSpinner({ size = 200, fullScreen = false }: LoadingSpinnerProps) {
  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      sx={{
        ...(fullScreen && {
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100vw',
          height: '100vh',
          backgroundColor: '#ffffff',
          zIndex: 9999,
        }),
        ...(!fullScreen && {
          width: '100%',
          height: '100%',
          minHeight: '400px',
          backgroundColor: '#ffffff',
          padding: '40px',
        }),
      }}
    >
      <img
        src="/loadingGif.gif"
        alt="Carregando..."
        style={{
          width: size,
          height: size,
          objectFit: 'contain',
        }}
      />
    </Box>
  );
}
